import InfiniteScroll from 'react-infinite-scroll-component';


export default function InfinityScroll({data=[], loadMoreAction, hasMore=false, children}) {
    console.log(hasMore)
    return (
        <InfiniteScroll
            style={{overflow: 'hidden'}}
            dataLength={data.length}
            next={loadMoreAction}
            hasMore={hasMore}
            loader={<></>}
        >
            {children}
        </InfiniteScroll>
    )
}
